import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Mars } from "../Pages/index";

class MyRouts extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/mars" component={Mars} />
        </Switch>
      </Router>
    );
  }
}
export default MyRouts;
